import { render } from "./aio-login-recent-activity.vue?vue&type=template&id=4b3e50c4&scoped=true"
import script from "./aio-login-recent-activity.vue?vue&type=script&lang=js"
export * from "./aio-login-recent-activity.vue?vue&type=script&lang=js"

import "./aio-login-recent-activity.vue?vue&type=style&index=0&id=4b3e50c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3e50c4"]])

export default __exports__